export default __webpack_public_path__ + "static/120422db-27fa-4ea0-b15c-8143059f8244-164cdf9e7c47ee5f8195245803cb82a5.woff";